import { Inject, Injectable } from '@angular/core';
import { LEGACY_MODE } from '../models/legacy-mode.model';

@Injectable({
  providedIn: 'root',
})
export class LegacyModeService {
  constructor(@Inject(LEGACY_MODE) private legacyMode: boolean) {}

  getLegacyMode(): boolean {
    return this.legacyMode;
  }
}
